<div class="narrow-container p-32:b p-48:t md:p-72:v lg:p-96:v">
    <div class="m-32:b md:m-64:b lg:m-72:b">
        <h1 class="align:c m-0:b">Dein Begleiter in allen Lebenslagen.</h1>
    </div>
    <div class="grid-container">
        <div class="intro-box g-12 md:g-8 md:g-offset-2 lg:g-4 lg:g-offset-0 bg:blue-1">
            <span class="h1">Einfach.</span>
            <p>Digitaler Abschluss in wenigen Schritten.</p>
        </div>
        <div class="intro-box g-12 md:g-8 md:g-offset-2 lg:g-4 lg:g-offset-0 bg:blue-2">
            <span class="h1">Transparent.</span>
            <p>Übersichtliche Konditionen und Vertragsbedingungen.</p>
        </div>
        <div class="intro-box g-12 md:g-8 md:g-offset-2 lg:g-4 lg:g-offset-0 bg:blue-3">
            <span class="h1">Glaubwürdig.</span>
            <p>Persönliche Kommunikation auf Augenhöhe.</p>
        </div>
    </div>
</div>
